"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeOrdersClient = void 0;
const test_support_1 = require("../../../test-support");
class FakeOrdersClient {
    constructor() {
        this.currentOrderID = 1618224199597;
        this.orders = [];
    }
    insertOrderFixture(order) {
        this.orders.push(test_support_1.OrdersFactory.sample(order));
    }
    get(id) {
        return Promise.resolve(this.orders.find((order) => order.id === id) || null);
    }
    getAllWithinDates(dateFromInclusive, dateToInclusive) {
        const dayEpochMillis = 86399999;
        const fromFilter = (order) => dateFromInclusive
            ? order.createdAt.getTime() >= new Date(dateFromInclusive).getTime()
            : true;
        const toFilter = (order) => dateToInclusive
            ? order.createdAt.getTime() <=
                new Date(dateToInclusive).getTime() + dayEpochMillis
            : true;
        return Promise.resolve(this.orders.filter(fromFilter).filter(toFilter));
    }
    getUserOrders(page, size) {
        return Promise.resolve({
            page: this.orders,
            pageSpec: {
                number: page,
                size: size,
                totalElements: this.orders.length,
                totalPages: 1,
            },
        });
    }
    async updateOrder(orderToUpdate, updateRequest) {
        const order = await this.get(orderToUpdate.id);
        if (!order) {
            throw new Error(`Cannot update order: ${orderToUpdate.id}`);
        }
        return Promise.resolve({
            ...order,
            ...{ status: updateRequest.status || order.status },
        });
    }
    updateItem(item, request) {
        return this.errorMessage
            ? Promise.reject({ message: this.errorMessage, reasons: this.reasons })
            : Promise.resolve(this.orders
                .map((order) => {
                const index = order.items.findIndex((it) => it.id === item.id);
                if (index < 0) {
                    return null;
                }
                const itemToUpdate = order.items[index];
                if (request.license) {
                    itemToUpdate.licenseInfo = {
                        duration: request.license.durationYears?.toString() ??
                            itemToUpdate.licenseInfo?.duration,
                        territory: request.license.territory ??
                            itemToUpdate.licenseInfo?.territory,
                    };
                }
                if (request.price) {
                    itemToUpdate.price = {
                        currency: itemToUpdate.price?.currency,
                        value: request.price,
                        displayValue: `${itemToUpdate.price?.currency} ${request.price}`,
                    };
                }
                if (request.captionsRequested) {
                    itemToUpdate.captionsRequested = request.captionsRequested;
                }
                return order;
            })
                .find((o) => o != null));
    }
    clear() {
        this.orders = [];
        this.placeOrderError = null;
    }
    rejectNextPlaceOrder(apiError) {
        this.placeOrderError = apiError;
    }
    placeOrder(request) {
        if (this.placeOrderError) {
            const error = Promise.reject(this.placeOrderError);
            this.placeOrderError = null;
            return error;
        }
        const orderItems = request.cart?.items?.map((item) => {
            return test_support_1.OrderItemFactory.sample({
                id: item?.id,
                video: test_support_1.OrderItemFactory.sampleVideo({ id: item?.videoId }),
                captionsRequested: item?.additionalServices?.captionsRequested,
                editRequest: item?.additionalServices?.editRequest,
                trim: item?.additionalServices?.trim &&
                    `${item.additionalServices?.trim?.from}-${item.additionalServices?.trim.to}`,
            });
        });
        const order = test_support_1.OrdersFactory.sample({
            id: this.generateOrderID(),
            createdAt: new Date(2011, 11, 1),
            updatedAt: new Date(2011, 11, 1),
            deliveredAt: new Date(2011, 11, 1),
            items: orderItems,
            note: request.cart.note,
            userDetails: {
                requestingUser: `${request.user.firstName} ${request.user.lastName}`,
                authorisingUser: `${request.user.firstName} ${request.user.lastName}`,
                account: request.user.account,
            },
        });
        this.orders.push(order);
        return Promise.resolve(order.id);
    }
    uploadOrdersCsv(_orders) {
        return this.errorMessage
            ? Promise.reject({
                message: this.errorMessage,
                reasons: this.reasons,
            })
            : Promise.resolve({
                message: 'Orders have been successfully imported!',
            });
    }
    exportOrdersCsv(orderExportRequest) {
        return Promise.resolve({
            content: `orders CSV from ${orderExportRequest.order_created_from} to ${orderExportRequest.order_created_to}`,
            filename: 'orders',
            mimeType: 'text/csv',
        });
    }
    getUploadOrdersCsvTemplate() {
        return Promise.resolve({
            content: 'upload orders csv template',
            filename: 'orders_template',
        });
    }
    setErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
    }
    setErrorReasons(reasons) {
        this.reasons = reasons;
    }
    generateOrderID() {
        return `${this.currentOrderID++}`;
    }
    markItemReadyForLicense(item) {
        if (this.errorMessage) {
            return Promise.reject({
                message: this.errorMessage,
                reasons: this.reasons,
            });
        }
        return Promise.resolve(this.orders
            .map((order) => {
            const index = order.items.findIndex((it) => it.id === item.id);
            if (index < 0) {
                return null;
            }
            const itemToUpdate = order.items[index];
            if (!itemToUpdate.links.markReadyForLicense) {
                throw Error('Not allowed to mark item ready for license');
            }
            itemToUpdate.links.markReadyForLicense = undefined;
            return order;
        })
            .find((o) => o != null));
    }
}
exports.FakeOrdersClient = FakeOrdersClient;
//# sourceMappingURL=FakeOrdersClient.js.map